export const goToBlock = (navigate, block, subtitle, destination) => {
  if (!block) return;

  navigate(
    `/single-destination/${block.title.toLowerCase().replace(/\s+/g, "-")}`,
    {
      state: {
        title: block.title,
        subtitle: subtitle, 
        images: block.images,
        items: block.items,
        description: block.description,
        howToReach: block.howToReach,
        history: block.history,
        bestTimeToVisit: block.bestTimeToVisit,
        nearbyAttractions: block.nearbyAttractions,
        destination: destination, 
      },
    }
  );
};
